import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Edasi ostukorvi

  <span style="color:#85c1dc;">**FI:**</span>
  Jatka ostoskoriin

  <span style="color:#85c1dc;">**RU:**</span>
  Перейти в корзину
*/
/* @__NO_SIDE_EFFECTS__ */
const m1861 = msg(
  mf`Edasi ostukorvi`,
  mf`Jatka ostoskoriin`,
  mf`Перейти в корзину`,
)

export { m1861 as 'w.module.product_modal.goto_cart' }